exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-863afb2e]{box-shadow:0 1px 3px rgba(0,0,0,.1)}.card-body[data-v-863afb2e]{padding:.75rem}.table th[data-v-863afb2e]{background-color:#f8f9fa;border-top:none}.table td[data-v-863afb2e],.table th[data-v-863afb2e]{font-size:.875rem}.alert ul[data-v-863afb2e]{margin-bottom:0}label[data-v-863afb2e]{font-size:.875rem;font-weight:500}h1[data-v-863afb2e]{font-size:1.5rem;margin-bottom:.5rem}h5[data-v-863afb2e]{font-size:1rem}", ""]);

// exports
